import React from 'react'
import{ FiUser, FiPhone, FiPlus, FiMapPin, FiMap } from'react-icons/fi'

export const profile_opts = [
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        }
    ]

export const profiles = [
    { id:null, title: 'Investment', job:['Job'], sector:['Sector'], position:['Position'], city:['Cairo'], desc:'Lorem ipsum dolor sit amet', },
    { id:null, title: 'Investment', job:['Job'], sector:['Sector'], position:['Position'], city:['Washington'], desc:'Lorem ipsum dolor sit amet', },
];

export const myprojects = [
    { title: 'BMW Transporter', img: ['/faces/1.png', '/faces/3.png', '/faces/4.png', '/faces/5.png', '/faces/6.png', '/faces/7.png'] },
    { title: 'Selling Apartment', img: ['/faces/2.png', '/faces/8.png', '/faces/11.png', '/faces/10.png'] },
    //  { title: 'Post 1', img: ['/faces/18.png', '/faces/17.png', '/faces/16.png'] },
    // { title: 'Post 3 ', img: ['/faces/19.png', '/faces/20.png'] },

]

export const requests = [
    { title: 'The Designer', desc: 'C++ developer at Microsoft', img: '/faces/1.png' },
    { title: 'The Author', desc: 'Freelance Graphics & UI Designer', img: '/faces/2.png' },
    { title: 'The Developer', desc: 'Designer & Illustrator', img: '/faces/3.png' },
    { title: 'The Writer', desc: 'Designer', img: '/faces/4.png' },
]
    
export const projects = [
    {title:"Project Design", where:'Netflix', place:'Shangai, CN', totalConnection:25, connections:['/faces/6.png','/faces/5.png','/faces/4.png'], date:'10 days ago'},
    {title:"Project Design", where:'Netflix', place:'Shangai, CN', totalConnection:67, connections:['/faces/6.png','/faces/5.png','/faces/4.png'], date:'10 days ago'},
]

export const users = [
    { title: 'Java Developer', desc: 'Oracle Inc.', img: null, symbol: null, shortname: 'AC', type: null },
    { title: '+90(512) 345 67 89', desc: null, img: null, symbol: <FiPhone />, shortname: null, type: null },
    { title: 'test@test.com', desc: null, img: null, symbol: <FiUser />, shortname: null, type: null },
    { title: 'Living in Egypt', desc: null, img: null, symbol: <FiMapPin />, shortname: null, type: null },
    { title: 'Knows Arabic & English', desc: null, img: "/assets/images/faces/1.png", symbol: null, shortname: null, type: null },
    { type: 'add', desc: 'Add School', title: null, img: null, symbol: <FiPlus />, shortname: null },
];

export const friends =  [
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/0.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/1.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/2.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/3.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/4.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/5.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/6.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/7.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/8.jpg' },
    { name:'Francisco Gibss', mutual: 130, avatar: '/projects/9.jpg' },
]

export const experiments = [
    {title:'Techical Support', company:'Floating Burger', date:'Marc 2014 ', desc:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text' },
    {title:'Co-Founder', company:'Unfold LLC', date:'Mar 23', desc:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text' },
]

export const educations = [
    {title:'Computer Science', company:'Mimar Sinan', date:'Mar 2012', desc:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text' },
]

export const tags = [
    {type:'city', title:'Marseille'},
    {type:'city', title:'Washington'},
    {type:'city', title:'Cairo'},
    {type:'skill',title:'Development'},
    {type:'skill',title:'Mobile Design'},
    {type:'skill',title:'Photography'}
]


export const smallGallery = [
    {img:'office'},
    {img:'code'},
    {img:'twitter'},
    {img:'car'},
    {img:'camera'},
]

export const aboutlist = [
    { letter: 'TA', title:'Java Developer', description:'Oracle Inc.'},
    {symbol: <FiMap />, title:'Participate Physics', description:'Washington'},
    {symbol: <FiPhone />, title:'0505 234 56 78'},
    {symbol: <FiUser />, title:'test@test.com'},
    {symbol: <FiMapPin />, title:'Living in Egypt'},
    {img: <img src="/assets/images/faces/1.png" alt="avatar" />, title:'Arabic, English knows'},
    {symbol: <FiPlus />, description:'Add School', add:true},
]
    


 